// @ts-ignore
import MainLayout from "@/Layouts/MainLayout";

import('./bootstrap');
import('moment');


import Vue from 'vue';

import {InertiaApp, plugin} from '@inertiajs/inertia-vue';
import VueMeta from 'vue-meta'
// import { InertiaForm } from 'laravel-jetstream';
import {Plugins, vuetify} from '@/plugins';


// @ts-ignore
Vue.mixin({ methods: { route } });
// @ts-ignore
Vue.use(plugin);
// Vue.use(InertiaForm);
Vue.use(Plugins);

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})

Vue.config.ignoredElements = [
    'mjml',
    'mj-body',
    'mj-section',
    'mj-column',
    'mj-image',
]

const app = document.getElementById('app');

// createInertiaApp({
//     resolve: (name) => import(`./Pages/${name}`).then(({default: page}) => {
//         page.layout = page.options?.layout?.options || page.layout || MainLayout;
//         console.log(MainLayout);
//         return page;
//     }),
//     setup({ el, app, props }) {
//         new Vue({
//             render: h => h(app, props),
//             vuetify
//         }).$mount(el)
//     },
// })


import Hotjar from 'vue-hotjar'

// Vue.use (Hotjar, {
//     id: '2507535' // Hotjar Site ID
// })

new Vue({
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => import(`./Pages/${name}`).then(({default: page}) => {
                    page.layout = page.options?.layout?.options || page.layout?.options || MainLayout;
                    return page;
                }),
            },
        }),
    vuetify,
}).$mount(app);
